export const SessionStatus = Object.freeze({
  Unmatched: 0,
  Unverified: 1,
  Verified: 2,
  Active: 3,
  Matched: 4
})

export const SessionResult = Object.freeze({
  Active: 0,
  Timeout: 1,
  Abandoned: 2,
  Complete: 3,
  LifelineTimeout: 4,
  LifelineUndo: 5,
  LifelineExit: 6,
  Error: 7,
  LifelineContactFailed: 8,
  Logout: 9,
  Bypass: 10,
  InvalidToken: 11,
  LifelineError: 12,
  ExpiredToken: 13,
  FrequencyBypass: 14,
  UnmatchedBypass: 15,
  LifelineSearch: 16,
  LifelineNoMatch: 17,
  SmsStopBypass: 18,
  SmsErrorBypass: 19,
  AutoBypass: 20,
  SmsBlockedBypass: 21,
  LifelineNoVerify: 22,
  LifelineLocked: 23
})

export const MFAStatus = Object.freeze({
  Disabled: 1,
  Pending: 2,
  Failed: 3,
  Success: 4
})

export const MFAMethod = Object.freeze({
  Email: 1,
  SMS: 2,
  Voice: 3
})

export const LifelineType = Object.freeze({
  Phone: 1,
  Email: 2,
  Chat: 3
})

export const ItemStatus = Object.freeze({
  Pending: 0,
  Trial: 1,
  Active: 2,
  Cancelled: 3,
  RecycleBillingFailed: 4,
  RecycleBilling: 5,
  Refunded: 6,
  Declined: 7,
  Complete: 8,
  Replaced: 9,
  Paused: 10,
  ThirdPartyCancel: 11,
  RecycleFailedHold: 12
})

export const ItemStatusStrings = [
  'Pending',
  'In Trial',
  'Active',
  'Cancelled',
  'Declined',
  'Declined - Reattempting',
  'Refunded',
  'Declined',
  'Complete',
  'Cancelled',
  'Paused',
  'Cancelled',
  'Declined'
]

export const ItemStatusClasses = [
  'pending',
  'active',
  'active',
  'cancelled',
  'cancelled',
  'pending',
  'cancelled',
  'cancelled',
  'active',
  'cancelled',
  'pending',
  'cancelled',
  'cancelled'
]

export const CustomerPortalInputType = Object.freeze({
  CustomerPortalHome: 30,
  CustomerPortalOrders: 31,
  CustomerPortalOrderHistory: 32,
  CustomerPortalPaymentInfo: 33,
  CustomerPortalPersonalInfo: 34,
  CustomerPortalOrderDetail: 35
})

export const QuantityType = Object.freeze({
  Any: 1,
  None: 2,
  LowerOnly: 3,
  HigherOnly: 4
})

export const InputType = Object.freeze({
  Choice: 0,
  Text: 1,
  Phone: 2,
  Item: 3,
  ActiveItem: 4,
  Product: 5,
  Faqs: 6,
  BillingAddress: 7,
  ShippingAddress: 8,
  ItemStatus: 9,
  InputActionStatus: 10,
  Radio: 11,
  Select: 12,
  NextSelectedItem: 13, // deprecated
  RadioSelect: 14,
  Hidden: 15,
  EnterProductFunnel: 16,
  PaymentInfo: 17,
  Link: 18,
  EnterTroubleshooter: 19,
  ContactCallCenter: 20,
  SelectCampaign: 21,
  MatchCustomer: 22,
  Date: 23,
  Checkout: 24,
  CheckoutConfirm: 25,
  RepeatActionHoldoff: 26,
  ShipmentTracking: 27,
  Confirmation: 28,
  ConfirmationNo: 29,
  CustomerPortalHome: 30,
  CustomerPortalOrders: 31,
  CustomerPortalOrderHistory: 32,
  CustomerPortalPaymentInfo: 33,
  CustomerPortalPersonalInfo: 34,
  CustomerPortalOrderDetail: 35,
  RepeatActionHoldoffResponse: 36,
  SubscriptionItem: 37,
  ChangeQuantity: 1001,
  ChangeInterval: 1002,
  Cancel: 1003,
  NoActiveItems: 1004,
  ChangeProduct: 1005,
  Return: 1006,
  Billing: 1007,
  AltChildExit: 1008,
  PathNotFound: 1009,
  NoCampaigns: 1010,
  CustomerNotFound: 1011,
  RebillItem: 1012,
  ShipmentReturnLabel: 1013,
  ShipmentReturnQRCode: 1014,
  PauseSubscription: 1015,
  SkipSubscription: 1016,
  ReactivateSubscription: 1017,
  CancelSubscription: 1018,
  CancelTrial: 1019,
  CancelSubscriptionHold: 1020,
  CancelTrialHold: 1021,
  ReturnSubscription: 1022,
  ReturnTrial: 1023
})

export const CustomerPortalTypes = [
  InputType.CustomerPortalHome,
  InputType.CustomerPortalOrders,
  InputType.CustomerPortalOrderHistory,
  InputType.CustomerPortalPaymentInfo,
  InputType.CustomerPortalPersonalInfo,
  InputType.CustomerPortalOrderDetail
]

export const BillingCycleType = Object.freeze({
  OneTime: 0,
  Recurring: 1,
  MultiPay: 2,
  RecurringChangeProduct: 3
})

export const FulfillmentStatus = Object.freeze({
  Hold: 0,
  Shipped: 1,
  Delivered: 2,
  RMAPending: 3,
  Returned: 4,
  Cancelled: 5,
  Processing: 6,
  PendingShipment: 7,
  Failed: 8,
  None: 9,
  NextCycle: 10,
  Removed: 11,
  ProcessingReattempt: 12,
  Skipped: 13,
  ParentOrder: 14
})

export const FulfillmentStatusStrings = [
  'Pending',
  'Shipped',
  'Delivered',
  'Return Pending',
  'Returned',
  'Cancelled',
  'Processed',
  'Shipped',
  'Failed',
  'No Shipment',
  'Next Cycle Product',
  'Cancelled',
  'Processing',
  'Skipped',
  'No Shipment'
]

export const FulfillmentStatusClasses = [
  'pending',
  'active',
  'active',
  'pending',
  'cancelled',
  'cancelled',
  'pending',
  'pending',
  'pending',
  'active',
  'pending',
  'cancelled',
  'pending',
  'cancelled',
  'pending'
]

export const ItemPendingStatus = Object.freeze({
  NotPending: 0,
  Cancel: 1,
  Return: 2,
  Exchange: 3,
  CancelSubscription: 4
})

export const ItemPendingStatusStrings = [
  'Not Pending',
  'Cancel Pending',
  'Return Pending',
  'Exchange Pending',
  'Cancel Subscription Pending'
]

export const TrackingStatus = Object.freeze({
  Unknown: 0,
  PreTransit: 1,
  InTransit: 2,
  OutForDelivery: 3,
  Delivered: 4,
  AvailableForPickup: 5,
  ReturnToSender: 6,
  Failure: 7,
  Cancelled: 8,
  Error: 9
})

export const TrackingStatusStrings = [
  'Not Found',
  'Pre-Transit',
  'In-Transit',
  'Out for Delivery',
  'Delivered',
  'Available for Pickup',
  'Alert/Exception',
  'Undelivered',
  'Expired',
  'Alert/Exception'
]

export const TrackingStatusDescriptionStrings = [
  'Tracking number not found. The carrier hasn\'t updated this package yet, or the number may be invalid.',
  'Pending shipment. A label has been created and the carrier is waiting to receive the package.',
  'Your package is on the way.',
  'Your package is out for delivery, stay tuned!',
  'The package is delivered',
  'Ready for pickup at your local carrier facility.',
  'There\'s an issue with your delivery (such as return to sender, or package damage).',
  'Delivery attempt unsuccessful. The courier will typically retry or provide pickup instructions.',
  'No tracking updates received for an extended time. The package may not have progressed.',
  'There\'s an issue with your delivery (such as return to sender, or package damage).'
]

export const TrackingStatusMissingDeliverDateStrings = [
  'We\'ll provide an estimated delivery date once your package begins its journey.',
  'We\'ll provide an estimated delivery date once your package begins its journey.',
  'Delivery date will be updated once available.',
  '',
  '',
  'Delivery date will be updated once available.',
  '',
  'Estimated delivery date will be available once the next attempt is scheduled.',
  '',
  ''
]

export const TrackingStatusClass = [
  'failure',
  'success',
  'success',
  'success',
  'success',
  'success',
  'failure',
  'failure',
  'failure',
  'failure'
]

export const PaymentSource = Object.freeze({
  CreditCard: 0,
  Check: 1,
  PrePaid: 2,
  COD: 3,
  DirectDebit: 4,
  PayPal: 5,
  ApplePay: 6,
  GooglePay: 7,
  Other: 8,
  Shopify: 9
})

export const PaymentSourceStrings = [
  'Credit Card',
  'Check',
  'Pre-Paid',
  'COD',
  'Direct Debit',
  'PayPal',
  'ApplePay',
  'GooglePay',
  'Other',
  'Shopify'
]

export const TranResponse = Object.freeze({
  Success: 0,
  SoftDecline: 1,
  HardDecline: 2
})

export const TranResponseStrings = [
  'Success',
  'Declined',
  'Declined'
]

export const TranResponseBadgeClass = [
  'active',
  'declined',
  'declined'
]

export const FunnelItemStatus = Object.freeze({
  InActive: -1,
  Active: 0,
  InTrial: 1,
  Hold: 2,
  Processing: 3,
  OneTimeShipped: 4,
  OneTimeInTrial: 5
})

export const InputState = Object.freeze({
  Unknown: 0,
  OkToSubmit: 1,
  NeedsMatch: 2,
  NeedsVerification: 3,
  OrderItemStatus: 4,
  InputFields: 5,
  RMAItems: 6,
  Variants: 7,
  RebillItems: 8
})

export const ProductStatus = Object.freeze({
  Normal: 0,
  ReadOnly: 1,
  Hidden: 2,
  Cancellable: 3,
  HideIfFreeFirstCycle: 4
})

export const FulfillmentType = Object.freeze({
  Standard: 0,
  NoShipping: 1
})

export const ProductType = Object.freeze({
  Offer: 0,
  Upsale: 1
})

export const ProcessType = Object.freeze({
  Sale: 1,
  Fee: 2,
  Warranty: 3,
  Installment: 4
})

export const VariantType = Object.freeze({
  None: 0,
  Standard: 1,
  Bundled: 2
})

export const CancelItemsSelection = Object.freeze({
  ShowAll: 1,
  ShowNone: 2,
  UpsellsOnly: 3,
  UpsellsOnlyIfUpsell: 4
})

export const TranslateTestString = 'dandruff'

export const ForceLogoutErrorCodes = [
  401 // unauthorized
]

export const OrderPaymentOptions = Object.freeze({
  Default: 0,
  New: 1
})

export const SubscriptionDisplayType = Object.freeze({
  Never: 1,
  Always: 2,
  AfterFirstCycle: 3
})

export const MobileIconButtonType = Object.freeze({
  Tile: 1,
  Box: 2
})

export const Countries = {
  US: 'United States of America',
  AU: 'Australia',
  CA: 'Canada',
  FR: 'France',
  DE: 'Germany',
  GB: 'United Kingdom',
  MX: 'Mexico'
}

export const Regions = {
  US: [
    {value: 'AL', text: 'Alabama'},
    {value: 'AK', text: 'Alaska'},
    {value: 'AZ', text: 'Arizona'},
    {value: 'AR', text: 'Arkansas'},
    {value: 'CA', text: 'California'},
    {value: 'CZ', text: 'Canal Zone'},
    {value: 'CO', text: 'Colorado'},
    {value: 'CT', text: 'Connecticut'},
    {value: 'DE', text: 'Delaware'},
    {value: 'DC', text: 'District Of Columbia'},
    {value: 'FL', text: 'Florida'},
    {value: 'GA', text: 'Georgia'},
    {value: 'GU', text: 'Guam'},
    {value: 'HI', text: 'Hawaii'},
    {value: 'ID', text: 'Idaho'},
    {value: 'IL', text: 'Illinois'},
    {value: 'IN', text: 'Indiana'},
    {value: 'IA', text: 'Iowa'},
    {value: 'KS', text: 'Kansas'},
    {value: 'KY', text: 'Kentucky'},
    {value: 'LA', text: 'Louisiana'},
    {value: 'ME', text: 'Maine'},
    {value: 'MD', text: 'Maryland'},
    {value: 'MA', text: 'Massachusetts'},
    {value: 'MI', text: 'Michigan'},
    {value: 'MN', text: 'Minnesota'},
    {value: 'MS', text: 'Mississippi'},
    {value: 'MO', text: 'Missouri'},
    {value: 'MT', text: 'Montana'},
    {value: 'NE', text: 'Nebraska'},
    {value: 'NV', text: 'Nevada'},
    {value: 'NH', text: 'New Hampshire'},
    {value: 'NJ', text: 'New Jersey'},
    {value: 'NM', text: 'New Mexico'},
    {value: 'NY', text: 'New York'},
    {value: 'NC', text: 'North Carolina'},
    {value: 'ND', text: 'North Dakota'},
    {value: 'OH', text: 'Ohio'},
    {value: 'OK', text: 'Oklahoma'},
    {value: 'OR', text: 'Oregon'},
    {value: 'PA', text: 'Pennsylvania'},
    {value: 'PR', text: 'Puerto Rico'},
    {value: 'RI', text: 'Rhode Island'},
    {value: 'SC', text: 'South Carolina'},
    {value: 'SD', text: 'South Dakota'},
    {value: 'TN', text: 'Tennessee'},
    {value: 'TX', text: 'Texas'},
    {value: 'UT', text: 'Utah'},
    {value: 'VT', text: 'Vermont'},
    {value: 'VI', text: 'Virgin Islands'},
    {value: 'VA', text: 'Virginia'},
    {value: 'WA', text: 'Washington'},
    {value: 'WV', text: 'West Virginia'},
    {value: 'WI', text: 'Wisconsin'},
    {value: 'WY', text: 'Wyoming'}
  ],
  CA: [
    {value: 'AB', text: 'Alberta'},
    {value: 'BC', text: 'British Columbia'},
    {value: 'MB', text: 'Manitoba'},
    {value: 'NB', text: 'New Brunswick'},
    {value: 'NL', text: 'Newfoundland and Labrador'},
    {value: 'NT', text: 'Northwest Territories'},
    {value: 'NS', text: 'Nova Scotia'},
    {value: 'NU', text: 'Nunavut'},
    {value: 'ON', text: 'Ontario'},
    {value: 'PE', text: 'Prince Edward Island'},
    {value: 'QC', text: 'Quebec'},
    {value: 'SK', text: 'Saskatchewan'},
    {value: 'YT', text: 'Yukon'}
  ]
}

export const PaymentStatusStrings = [
  'Unpaid',
  'Paid',
  'Refunded',
  'Declined',
  'Partially Refunded'
]

export const PaymentStatusClasses = [
  'pending',
  'active',
  'refund',
  'cancelled',
  'refund'
]

export const PaymentUpdateAllowed = {
  NO: 0,
  YES: 1,
  EXPIRY_ONLY: 2
}

export const StepButtonType = {
  Flat: 0,
  Modern: 1,
  Pill: 2,
  FlatOutline: 3,
  ModernOutline: 4,
  PillOutline: 5,
  TextOnly: 6
}

export const CheckoutSteps = Object.freeze({
  SelectItems: 1,
  AddressInfo: 2,
  PaymentInfo: 3,
  OrderPlaced: 4
})

export const CheckoutStepsTitle = Object.freeze({
  [CheckoutSteps.SelectItems]: 'Please select the item(s)',
  [CheckoutSteps.AddressInfo]: 'Shipping Information',
  [CheckoutSteps.PaymentInfo]: 'Payment Method'
})

export const IntentLabels = Object.freeze({
  [InputType.Cancel]: 'Cancel Shipment',
  [InputType.Return]: 'Return Product',
  [InputType.ReturnTrial]: 'Return Product',
  [InputType.ReturnSubscription]: 'Return Product',
  [InputType.SkipSubscription]: 'Skip Shipment',
  [InputType.ChangeProduct]: 'Revise Package',
  [InputType.ChangeInterval]: 'Shipping Frequency',
  [InputType.PauseSubscription]: 'Pause Subscription',
  [InputType.CancelSubscription]: 'Cancel Subscription',
  [InputType.ReactivateSubscription]: 'Re-Activate',
  [InputType.CancelTrial]: 'Cancel Trial',
  [InputType.CancelSubscriptionHold]: 'Cancel Shipment',
  [InputType.CancelTrialHold]: 'Cancel Trial'
})

export const DefaultCustomerPortalSettings = Object.freeze({
  side_menu_inputs: []
})

export const BASE_WIDTH = 430

export const PopupCloseSetting = Object.freeze({
  NoClose: 1,
  Undo: 2,
  FirstInput: 3,
  LastInput: 4,
  UndoOrFirstInput: 5,
  UndoOrLastInput: 6
})

export const ExternalStepKey = '_external'

export const MessageDisplayTime = 5000 // 5 seconds
export const CustomerMatchMessages = [
  'Looking you up... hang tight!', 'Still searching... almost there!'
]
export const CustomerVerifyMessages = [
  'Verifying info... one sec!', 'Double-checking... thanks for waiting!'
]
export const ActionMessages = [
  [],
  ['Processing cancellation...', 'Finalizing... almost there!'],
  ['Processing return...', 'Finalizing return... hang tight!'],
  ['Setting up exchange...', 'Confirming details... one sec!'],
  ['Applying your offer...', 'Locking it in... hang on!'],
  ['Updating order...', 'Making changes... almost there!'],
  ['Applying discount...', 'Updating subscription... done soon!'],
  ['Upgrading order...', 'Adding upgrade... hold on!'],
  ['Adjusting subscription...', 'Updating plan... one sec!'],
  ['Processing refund & update...', 'Finalizing changes...'],
  ['Canceling... hold on!', 'Wrapping up... almost done!'],
  ['Applying your offer...', 'Locking it in... hang on!'],
  ['Pausing... one moment!', 'Hold in place... almost done!'],
  ['Finalizing purchase...', 'Processing... hang on!'],
  ['Processing payment...', 'Confirming... one sec!'],
  ['Extending return...', 'Updating eligibility...'],
  ['Updating details...', 'Finalizing changes...'],
  ['Reactivating...', 'Bringing it back...'],
  ['Checking your request...', 'Reviewing... hang tight!'],
  ['Updating address...', 'Saving... almost there!'],
  ['Saving payment info...', 'Securing details...'],
  ['Fetching tracking...', 'Locating package...'],
  ['Creating return label...', 'Generating... hold tight!'],
  ['Extending trial...', 'Updating... almost done!']
]

export const ContentWidthDeviceSize = Object.freeze({
  Mobile: 'mobile',
  Tablet: 'tablet',
  Desktop: 'desktop'
})

export const ContentWidthDeviceSizeToClass = Object.freeze({
  [ContentWidthDeviceSize.Desktop]: 'lg',
  [ContentWidthDeviceSize.Tablet]: 'md',
  [ContentWidthDeviceSize.Mobile]: 'sm'
})

export const StepsExcludedFromMouseflow = [
  InputType.Product,
  InputType.PaymentInfo,
  InputType.Faqs,
  InputType.ItemStatus,
  InputType.InputActionStatus,
  InputType.BillingAddress,
  InputType.ShippingAddress
]

export const VerificationFieldsHelpText = Object.freeze({
  last_name: 'Enter the last name on your billing profile.',
  zip: 'Enter the billing ZIP code for the card used.'
})

export const LabelTypes = Object.freeze({
  SubscriptionStatus: '1'
})

export const ShowBreadcrumbs = Object.freeze({
  OnlyIfCanUndo: 1,
  Always: 2,
  Never: 3
})
